module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-900-black-ba08814244b702f9dbf157e40fefb484.woff";